export const moduleClassMapper = (classes, moduleClass) =>
  classes
    .split(" ")
    .map((value) => moduleClass[value])
    .join(" ");
